import type { RouteLocationGeneric, RouteRecordRaw } from 'vue-router'
import { PSI_SHIPPING_INTEGRATION_FEATURE_ENABLED } from '@/constants/psiRelease'

const warehouseRoutes: RouteRecordRaw[] = [
  {
    path: 'warehouse',
    component: () => import('@/pages/warehouse/layout.vue'),
    meta: { title: '仓库', requiresPsi: true },
    children: [
      {
        path: '',
        name: 'Warehouse',
        component: () => import('@/pages/warehouse/index.vue'),
        meta: { title: '仓库资料' },
      },
      {
        path: 'products',
        name: 'WarehouseProducts',
        component: () => import('@/pages/warehouse-products/index.vue'),
        meta: { title: '仓库商品管理' },
      },
      {
        path: 'product-stats',
        name: 'WarehouseProductStats',
        component: () => import('@/pages/warehouse-product-stats/index.vue'),
        meta: { title: '仓库库存商品统计' },
      },
      {
        path: 'product-inventory-stats',
        name: 'ProductInventoryStats',
        component: () => import('@/pages/product-inventory-stats/index.vue'),
        meta: { title: '商品进销存统计表' },
      },
      {
        path: 'product-inventory-daily-report',
        name: 'ProductInventoryDailyReport',
        component: () => import('@/pages/product-inventory-daily-report/index.vue'),
        meta: { title: '商品进销存日报表' },
      },
      {
        path: 'shipping-workbench',
        name: 'WarehouseShippingWorkbench',
        component: () => import('@/pages/warehouse/shipping-workbench.vue'),
        meta: { title: '发货台' },
      },
      {
        path: 'logistics-reconciliation',
        name: 'WarehouseLogisticsReconciliation',
        redirect: (to: RouteLocationGeneric) => {
          const { tab, ...query } = to.query
          const path =
            tab === 'audit'
              ? '/finance/logistics-reconciliation/audit'
              : tab === 'unsettled'
                ? '/finance/logistics-reconciliation/unsettled'
                : '/finance/logistics-reconciliation/import'
          return { path, query }
        },
        meta: { title: '物流对账', requiresPsi: true },
      },
      ...(PSI_SHIPPING_INTEGRATION_FEATURE_ENABLED
        ? [
            {
              path: 'eorder-shipping',
              name: 'WarehouseEorderShipping',
              component: () => import('@/pages/warehouse/eorder-shipping.vue'),
              meta: { title: '打单发货' },
            },
          ]
        : []),
      {
        path: 'delivery-import',
        name: 'WarehouseDeliveryImport',
        component: () => import('@/pages/warehouse/delivery-import.vue'),
        meta: { title: '导入发货' },
      },
      {
        path: 'scan-check',
        name: 'WarehouseShippingScan',
        component: () => import('@/pages/warehouse/shipping-scan.vue'),
        meta: { title: '扫码验单' },
      },
      {
        path: 'shipping-tasks/detail',
        name: 'WarehouseShippingTaskDetail',
        component: () => import('@/pages/warehouse/shipping-task-detail.vue'),
        meta: { title: '发货任务详情' },
      },
      {
        path: 'inventory-bills',
        name: 'InventoryBills',
        component: () => import('@/pages/inventory-bills/index.vue'),
        meta: { title: '库存单据' },
      },
      {
        path: 'inventory-bills/edit',
        name: 'InventoryBillEdit',
        component: () => import('@/pages/inventory-bills/edit.vue'),
        meta: { title: '编辑库存单据' },
      },
      {
        path: 'inventory-bills/detail',
        name: 'InventoryBillDetail',
        component: () => import('@/pages/inventory-bills/detail.vue'),
        meta: { title: '库存单据详情' },
      },
      {
        path: 'stock-check',
        name: 'StockCheck',
        component: () => import('@/pages/stock-check/index.vue'),
        meta: { title: '库存盘点' },
      },
      {
        path: 'stock-check/edit',
        name: 'StockCheckEdit',
        component: () => import('@/pages/stock-check/edit.vue'),
        meta: { title: '盘点录入' },
      },
      {
        path: 'inventory-logs',
        name: 'InventoryLogs',
        component: () => import('@/pages/inventory-logs/index.vue'),
        meta: { title: '库存日志' },
      },
      {
        path: 'inventory-reports',
        name: 'InventoryReports',
        component: () => import('@/pages/inventory-reports/index.vue'),
        meta: { title: '库存报表' },
      },
    ],
  },
  {
    path: 'warehouse-products',
    redirect: (to) => ({ path: '/warehouse/products', query: to.query }),
  },
  {
    path: 'warehouse-shipping-workbench',
    redirect: (to) => ({ path: '/warehouse/shipping-workbench', query: to.query }),
  },
  ...(PSI_SHIPPING_INTEGRATION_FEATURE_ENABLED
    ? [
        {
          path: 'warehouse-eorder-shipping',
          redirect: (to: RouteLocationGeneric) => ({ path: '/warehouse/eorder-shipping', query: to.query }),
        },
      ]
    : []),
  {
    path: 'inventory-bills',
    redirect: (to) => ({ path: '/warehouse/inventory-bills', query: to.query }),
  },
  {
    path: 'inventory-bills/edit',
    redirect: (to) => ({ path: '/warehouse/inventory-bills/edit', query: to.query }),
  },
  {
    path: 'inventory-bills/detail',
    redirect: (to) => ({ path: '/warehouse/inventory-bills/detail', query: to.query }),
  },
  {
    path: 'stock-check',
    redirect: (to) => ({ path: '/warehouse/stock-check', query: to.query }),
  },
  {
    path: 'stock-check/edit',
    redirect: (to) => ({ path: '/warehouse/stock-check/edit', query: to.query }),
  },
  {
    path: 'inventory-logs',
    redirect: (to) => ({ path: '/warehouse/inventory-logs', query: to.query }),
  },
  {
    path: 'inventory-reports',
    redirect: (to) => ({ path: '/warehouse/inventory-reports', query: to.query }),
  },
]

export default warehouseRoutes
